import Vue from 'vue';
import Component from 'vue-class-component';
import './clubcard-has-question.scss';
import {RegistrationVue} from '@/registration-vue';
declare var dataLayer: any;
declare var memberStatus: boolean;

@Component({
  template: `
<registration-page centered="true" class="has-question">
  <h1>Do you have a New World Clubcard?</h1>
  <button @click="no" class="button inverted qa-no-button">No</button>
  <button @click="yes" class="button inverted qa-yes-button">Yes</button>
</registration-page>
`
})
export class ClubCardHasQuestionPage extends RegistrationVue {

  fullRegistrationEnabled: boolean = FULLREGISTER_ENABLED;

  mounted() {
    this.$store.state.firstName = '';
    this.$store.state.lastName = '';
    this.$store.state.phoneNumber = '';

    dataLayer.push({
      'event': 'stepLoaded',
      'stepNumber': '2',
      'stepName': 'Do you have a club card'
    });
  }

  yes() {
    this.$store.state.isQuickShopper = false;
    memberStatus = true;
    dataLayer.push({
      'event': 'clubcardStatus',
      'clubCard': 'yes'
    });
    this.navigate('clubcard-entry');
  }

  no() {
    memberStatus = false;
    dataLayer.push({
      'event': 'clubCardStatus',
      'clubCard': 'no'
    });

    if (this.fullRegistrationEnabled) {
      this.navigate('clubcard-choose-reward');
    } else {
      this.$store.state.isQuickShopper = true;
      this.navigate('security-entry');
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/forms/clubcard-has-question/clubcard-has-question.ts